// AboutFlame.tsx
import React from "react";
import "./index.css";

export default function AboutFlame({toggleModal = () => {}}) {
  return (
    <section className="about-flame">
      <div className="about-flame__content">
        <h2 className="about-flame__title">ABOUT FLAME UNIVERSITY</h2>
        <p className="about-flame__description">
          Set on a sprawling campus in Pune, FLAME University is one of India’s
          leading liberal education institutions. With its blend of modern
          infrastructure and natural landscapes, FLAME creates an environment
          that feels both expansive and personal. Students from across the
          country come here to study, explore, and grow not just academically,
          but as thinkers and leaders. Its commitment to dialogue, diversity,
          and interdisciplinary learning makes it an ideal setting for OxfordMUN
          India 2025, offering an atmosphere that inspires dialogue, leadership,
          and global thinking in every corner.
        </p>

        <div className="about-flame__buttons">
          <button
            className="primary-btn"
            onClick={toggleModal}
          >
            REGISTER NOW
          </button>
          <a
            className="secondary-btn"
            href="https://bit.ly/OxfordMUNIndia2025Brochure"
            target="_blank"
          >
            DOWNLOAD BROCHURE
          </a>
        </div>

        <div className="about-flame__image-wrapper">
          {/* <img
            src="/assets/images/OxfordMunNew/flame_university_img.svg"
            alt="Flame University"
            className="about-flame__image"
          /> */}
        </div>

        <hr className="about-flame__divider" />
      </div>
    </section>
  );
}
